export default {
    columnHeader: {
        fontWeight: 700,
        padding: 8,
        flexShrink: 1,
    } as React.CSSProperties,

    headerRow: {
        width: "100%",
        height: 48,
        backgroundColor: "#ffffff",
        textAlign: "left",
    } as React.CSSProperties,

    tableRowOdd: {
        width: "100%",
        height: 48,
        backgroundColor: "#ffffff",
    } as React.CSSProperties,

    tableRowEven: {
        width: "100%",
        height: 48,
        backgroundColor: "#f9f9f9",
    } as React.CSSProperties,

    tableCell: {
        padding: 8,
    } as React.CSSProperties,

    noData: {
        width: "auto",
        border: "solid 1px #eee",
        background: "#F8F8FD",
        padding: 20,
        textAlign: "center"
    } as React.CSSProperties,
}
